import { ButtonComponentConfig, ButtonSize } from '@rappider/rappider-components/utils';
import { POP_CONFIRM_DELETE_ACTION } from 'libs/shared/src/lib/configs/pop-confirm-button/pop-confirm-button-config';

export const DiagramButtonConfig: ButtonComponentConfig[] = [
  {
    icon: { name: 'far fa-circle' },
    text: 'Start A New Workflow',
    size: ButtonSize.Small
  },
  // {
  //   icon: { name: 'far fa-rectangle' },
  //   text: 'Create Workflow Step Function',
  //   size: ButtonSize.Small
  // },
  {
    key: 'refreshWorkflowData',
    text: 'Refresh Workflow Data',
    icon: { name: 'fa fa-refresh' },
    size: ButtonSize.Small
  },
  // {
  //   key: 'zoomToFit',
  //   text: 'Zoom to Fit',
  //   icon: { name: 'fa fa-expand' },
  //   size: ButtonSize.Small
  // }
];

export const workflowEventDeleteAllWorkflowConfig = {
    text: 'Delete',
    name: POP_CONFIRM_DELETE_ACTION.name,
    popconfirmTitle: POP_CONFIRM_DELETE_ACTION.popconfirmTitle,
    emitWithoutPopconfirm: POP_CONFIRM_DELETE_ACTION.emitWithoutPopconfirm,
    behavior: POP_CONFIRM_DELETE_ACTION.behavior,
    popconfirmCancelText: POP_CONFIRM_DELETE_ACTION.popconfirmCancelText,
    popconfirmOkText: POP_CONFIRM_DELETE_ACTION.popconfirmOkText,
    popconfirmOkDanger: POP_CONFIRM_DELETE_ACTION.popconfirmOkDanger,
  }
